<template>
  <div>
    <h1 v-html="$t('view.component.topup.auto.sidebar.header')"></h1>
    <ol>
      <li v-html="$t('view.component.topup.auto.sidebar.text1')"></li>
      <li v-html="$t('view.component.topup.auto.sidebar.text2')"></li>
      <li v-html="$t('view.component.topup.auto.sidebar.text3')"></li>
      <li v-html="$t('view.component.topup.auto.sidebar.text4')"></li>
      <li v-html="$t('view.component.topup.auto.sidebar.text5')"></li>
      <li v-html="$t('view.component.topup.auto.sidebar.text6')"></li>
    </ol>
    <p v-html="$t('view.component.topup.auto.sidebar.text7')"></p>
    <p><a class="with-hint">{{ $t('view.component.topup.auto.sidebar.text8') }} <span v-tooltip="$t('view.component.topup.auto.sidebar.tooltip')"></span></a></p>
    <p><router-link :to="lpLink">{{ $t('view.component.topup.auto.sidebar.text9') }}</router-link></p>
  </div>
</template>

<script>
import { ROUTING } from '@/orange/const/routing.const'

export default {
  name: 'AutoTopupSidebar',
  data () {
    return {
      tooltip: {
        html: true
      },
      lpLink: ROUTING.topup.auto.lp
    }
  }
}
</script>
